module.exports = __webpack_public_path__ + "static/B&S-528d5a46635121c3eff7b4e0f2802e3e.png";